/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Participation } from '../models/Participation';
import type { ParticipationTab } from '../models/ParticipationTab';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipationService {

    /**
     * List Participation Templates
     * @returns any Success
     * @throws ApiError
     */
    public static listParticipationTemplates({
        vendor,
        profile,
        search,
        offset,
        limit,
        order,
    }: {
        vendor?: string,
        profile?: string,
        search?: string,
        offset?: number,
        limit?: number,
        order?: Record<string, any>,
    }): CancelablePromise<{
        rows: any[];
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation',
            query: {
                'vendor': vendor,
                'profile': profile,
                'search': search,
                'offset': offset,
                'limit': limit,
                'order': order,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add multiple Participation Templates
     * @returns any Success
     * @throws ApiError
     */
    public static massCreate({
        requestBody,
    }: {
        requestBody?: {
            participationIds: Array<string>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/massCreate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete multiple Participation Templates
     * @returns any Success
     * @throws ApiError
     */
    public static massDelete({
        requestBody,
    }: {
        requestBody?: {
            participationIds: Array<string>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/massDelete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template
     * @returns Participation Success
     * @throws ApiError
     */
    public static getParticipationTemplate({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<Participation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Field Mappings
     * @returns any Success - Returns all compensation tabs with merged field mappings
     * @throws ApiError
     */
    public static getParticipationFieldMappings({
        participationId,
    }: {
        participationId: string,
    }): CancelablePromise<{
        tabs?: Array<ParticipationTab>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/fieldMappings',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static getParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody: {
            plan: number;
            mappingType: Array<SurveyJobCompanyJobMappingStatus>;
            tabName: string;
            module?: Array<string>;
            country?: Array<string>;
            state?: Array<string>;
            customField?: Array<string>;
            typeOfPay?: SalaryRangeTypeOfPay;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
            includeSlottedMappings?: boolean;
        },
    }): CancelablePromise<{
        rows?: any[];
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/data',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export Participation Template Data
     * @returns any Success
     * @throws ApiError
     */
    public static exportParticipationData({
        participationId,
        requestBody,
    }: {
        participationId: string,
        requestBody?: {
            plan: number;
            mappingType: Array<string>;
            module?: Array<string>;
            typeOfPay?: SalaryRangeTypeOfPay;
            includeSlottedMappings?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participation/{participationId}/export',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
